import styled, { css } from '../../../theme'

const Currency = styled.div<{ size?: number; little? :boolean }>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  color: #969696;
    
  ${({ little }) => little ? css`
      color: #C2C2C2;

      text-align: center;
      font-family: Montserrat, sans-serif;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.02px;
  ` : ''};
    
`

export default Currency
